import { HttpStatusCode } from 'axios';

export interface ApiError {
	error: string;
	message: ErrorCode | ErrorCode[] | string | string[];
	status: HttpStatusCode;
}

export interface AppError {
	status: HttpStatusCode;
	stack: (ErrorCode | string)[];
	message: string;
}

export enum ErrorCode {
	GENERIC = 'genericError',
	USER_NOT_FOUND = 'userNotFound',
	USER_NOT_ACTIVE = 'userNotActive',
	USER_ALREADY_EXISTS = 'userAlreadyExists',
	DUPLICATED_EMAIL = 'duplicatedEmail',
	MISSING_FIELD = 'missingField',
	EMAIL_NOT_FOUND = 'emailNotFound',
	INVALID_EMAIL = 'emailIsNotValid',
	INVALID_PASSWORD = 'invalidPassword',
	INVALID_PHONE_NUMBER = 'phoneNumberIsNotValid',
	PASSWORD_TOO_WEAK = 'passwordTooWeak',
	DIFFERENT_PASSWORDS = 'differentPasswords',
	DIFFERENT_EMAILS = 'differentEmails',
	INVALID_REFRESH_TOKEN = 'invalidRefreshToken',
	REFRESH_TOKEN_EXPIRED = 'refreshTokenExpired',
	REFRESH_TOKEN_MALFORMED = 'refreshTokenMalformed',
	INVALID_TOKEN = 'invalidToken',
	INVALID_HASH = 'invalidHash',
	INVALID_POSTAL_CODE = 'invalidPostalCode',
	TOO_MANY_REQUESTS = 'tooManyRequests',
	INVALID_EMAIL_DOMAIN = 'invalidEmailDomain',
	REGISTRATION_FAILED = 'registrationFailed',
	PASSWORD_TO_WEAK = 'passwordToWeak',
	INVALID_FILE_TYPE = 'invalidFileType',
}

export const getErrorMessage = (codes: ErrorCode[] | string[]) => {
	const codeToMessage = (code: ErrorCode | string) => {
		switch (code) {
			case ErrorCode.PASSWORD_TO_WEAK:
				return 'Hasło nie spełnia wymogów bezpieczeństwa!';
			case ErrorCode.INVALID_FILE_TYPE:
				return 'Format pliku nieobsługiwany!';
			case ErrorCode.USER_NOT_FOUND:
				return 'Taki email nie istnieje w systemie.';
			case ErrorCode.INVALID_PASSWORD:
				return 'Podane hasło jest nieprawidłowe!';
			case ErrorCode.DUPLICATED_EMAIL:
				return 'Podany adres email jest już zajęty!';
			case ErrorCode.INVALID_REFRESH_TOKEN:
				return 'Nieprawidłowy token!';
			case ErrorCode.REFRESH_TOKEN_EXPIRED:
				return 'Token wygasł!';
			case ErrorCode.INVALID_TOKEN:
				return 'Podano nieprawidłowy token!';
			case ErrorCode.INVALID_HASH:
				return 'Podano nieprawidłowy token!';
			case ErrorCode.MISSING_FIELD:
				return 'Nie podano jednego z wymaganych pól!';
			case ErrorCode.USER_ALREADY_EXISTS:
				return 'Ten adres email jest już zajęty';

			default:
				return '';
		}
	};

	const errorMessages = codes.map((code) => codeToMessage(code));

	const message =
		errorMessages.filter((m) => !!m).join('. ') ||
		'Coś poszło nie tak! Spróbuj ponownie później.';

	return message;
};
